(() => {
  const players = document.querySelectorAll('[data-audio-player]');
  let currentlyPlaying = null;

  players.forEach(player => {
    const audio = player.querySelector('audio');
    const playBtn = player.querySelector('.audio-play');
    const restartBtn = player.querySelector('.audio-restart');
    const progress = player.querySelector('[data-progress]');
    const fill = player.querySelector('.audio-progress-fill');
    const handle = player.querySelector('.audio-progress-handle');

    playBtn.addEventListener('click', () => {
      if (audio.paused) {
        if (currentlyPlaying && currentlyPlaying !== audio) {
          currentlyPlaying.pause();
        }
        audio.play();
        currentlyPlaying = audio;
        playBtn.classList.add('is-playing');
        playBtn.textContent = '❚❚';
      } else {
        audio.pause();
        playBtn.classList.remove('is-playing');
        playBtn.textContent = '▶';
      }
    });

    restartBtn.addEventListener('click', () => {
      audio.currentTime = 0;
      audio.play();
      playBtn.classList.add('is-playing');
      playBtn.textContent = '❚❚';
    });

    audio.addEventListener('timeupdate', () => {
      const percent = (audio.currentTime / audio.duration) * 100;
      fill.style.width = `${percent}%`;
      handle.style.left = `${percent}%`;
    });

    audio.addEventListener('ended', () => {
      playBtn.classList.remove('is-playing');
      playBtn.textContent = '▶';
    });

    progress.addEventListener('click', e => {
      const rect = progress.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const percent = clickX / rect.width;
      audio.currentTime = percent * audio.duration;
    });
  });
})();
